<template>
	<div class="sy-ch-main container-fluid mt3">
		<!-- <div class = "managerNavs" v-for = "(tab,index) in navPaths">
			<router-link v-bind:to = "{path: tab.path}" > 
				{{tab.name}}
			</router-link>
		</div> -->
		<div class="container500">
			<router-link v-bind:to = "{path: tab.path}" v-for = "tab in navPaths" :key = "tab.name">
				<div class="btn mb3 profileManagerNavs" >
					{{tab.name}}
				</div>
			</router-link>
		</div>
		<div class="container500">
			<router-view v-if = "loaded"></router-view>
		</div>
	</div>
</template>

<style>
.selectedNav a{
	color: black;
	background-color: white;
}
.selectedNav{
	background-color: white;
}
</style>
<script>
var dbPath, docID;
export default{
	data(){
		var prefix = "/" + this.$route.params.businessID;
		this.$store.commit("loadState", this.$route.params.businessID);
		var language = this.$store.getters.getLanguage();
		return{
			navPaths:[
			// {
			// 	path: prefix + '/manager/products',
			// 	name: copywriting[language]['Product'],
			// },
			{
				path: prefix + '/manager/categories',
				name: copywriting[language]['Categories'],
			},
			{
				path: prefix + '/manager/schedule',
				name: copywriting[language]['Holidays'],
			},
			{
				path: prefix + '/manager/setting',
				name: copywriting[language]['Setting'],
			},
			],
			preOrderSetting: {},
			loaded: false,
			specialSchedule: [],
			specialSchedules: {},
			copywriting: copywriting,
			language: language
		}
	},
	mounted(){
		this.checkPath();
		customJS.runAll();
	},
	watch:{
		"specialSchedule"(){
			var specialSchedules = {};
			var dateString;
			this.specialSchedule.forEach(r=>{
				for (var month in r.Schedule){
					for (var day in r.Schedule[month]){
						dateString = myDate.displayDate(new Date(r[".key"] + "-" + month + "-" +  day).getTime());
						specialSchedules[dateString] = r.Schedule[month][day].Sessions;
					}
				}
			})
			this.specialSchedules = specialSchedules;
		},
		"$route.path"(){
			this.routeHandle();
		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings";
		docID = "preOrderSetting";
		this.$binding("preOrderSetting", myFB.db.collection(dbPath).doc(docID)).then(r=>{
			this.$binding("specialSchedule", myFB.db.collection(dbPath + "/" + docID + "/allSchedule").orderBy("Date").where("Date", ">=", myDate.getTime())).then(r2=>{
				var specialSchedules = {};
				var dateString;
				this.specialSchedule.forEach(r=>{
					for (var month in r.Schedule){
						for (var day in r.Schedule[month]){
							dateString = myDate.displayDate(new Date(r[".key"] + "-" + month + "-" +  day).getTime());
							specialSchedules[dateString] = r.Schedule[month][day].Sessions;
						}
					}
				})
				this.specialSchedules = specialSchedules;
				this.loaded = true;
			})
		}).catch(e=>{
			console.log(e.message);
		});
	},
	watch:{
		"$route":function(){
			this.checkPath();
		}
	},
	methods:{
		checkPath(){
			var path = this.$route.path;
			var allPaths = [];

			this.navPaths.forEach(r=>{
				allPaths.push(r.path);
			})


			var chosenIndex = allPaths.indexOf(path) + 1;
			$(".managerNavs").removeClass("selectedNav");
			if (chosenIndex != 0){
				$(".managerNavs:nth-of-type(" + chosenIndex + ")").addClass("selectedNav");
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Manager.vue